if (!customElements.get('store-stock')) {
    class StoreStock extends HTMLElement {
        static SELECTED_STORE_KEY = 'vlisco_selected_store';

        connectedCallback() {
            this.sectionId = this.dataset.sectionId;
            this.rootUrl = this.dataset.rootUrl || '/';

            if (!this.rootUrl.endsWith('/')) this.rootUrl += '/';

            this.parser = new DOMParser();
            this.cache = this.availabilityMap;
            this.textElement = this.querySelector('[data-store-stock-text]');
            this.linkElement = this.querySelector('[data-store-stock-link]');

            if (this.selectedStoreId) this.blockAddButton();

            if (this.linkElement) {
                this.linkElement.addEventListener('click', () => {
                    document.dispatchEvent(new CustomEvent('store-selector:open'));
                });
            }

            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
                    if (event.data.sectionId !== this.sectionId) return;

                    this.update(event.data.variant && event.data.variant.id);
                });
            }

            this.update();
        }

        disconnectedCallback() {
            if (this.unsubscribe) this.unsubscribe();
        }

        parseJSON(id, fallback) {
            const element = document.getElementById(id);

            if (!element) return fallback;

            try {
                return JSON.parse(element.textContent) || fallback;
            } catch (error) {
                return fallback;
            }
        }

        get locations() {
            return this.parseJSON(`store-stock-locations-${this.sectionId}`, []);
        }

        get availabilityMap() {
            return this.parseJSON(`store-stock-availability-${this.sectionId}`, {});
        }

        get selectedStoreId() {
            return localStorage.getItem(StoreStock.SELECTED_STORE_KEY) || '';
        }

        storeName(id) {
            const match = this.locations.find((location) => String(location.id) === String(id));

            return match ? match.name : '';
        }

        currentVariantId() {
            const input = document.querySelector(`#product-form-${this.sectionId} .product-variant-id`) ||
                document.querySelector('.product-variant-id');

            return input && input.value;
        }

        async availabilityFor(variantId) {
            if (this.cache[variantId]) return this.cache[variantId];

            try {
                const url = `${this.rootUrl}variants/${variantId}/?section_id=store-availability`;
                const response = await fetch(url);
                const text = await response.text();
                const element = this.parser
                    .parseFromString(text, 'text/html')
                    .querySelector('[data-store-availability]');
                const map = element ? JSON.parse(element.textContent) : {};

                this.cache[variantId] = map[variantId] || {};
            } catch (error) {
                console.error(error);
                return {};
            }

            return this.cache[variantId];
        }

        availableAt(availability, storeId) {
            if (!availability) return false;

            const numericId = String(storeId).replace(/\D/g, '');

            return availability[numericId] === true || availability[storeId] === true;
        }

        async update(variantId) {
            const storeId = this.selectedStoreId;
            const currentVariantId = variantId || this.currentVariantId();

            if (!storeId || !currentVariantId) {
                this.hidden = true;

                return;
            }

            this.pendingVariantId = currentVariantId;
            const availability = await this.availabilityFor(currentVariantId);

            if (this.pendingVariantId !== currentVariantId) return;

            const name = this.storeName(storeId);
            const available = this.availableAt(availability, storeId);

            this.hidden = false;

            if (this.textElement) {
                const template = available ? this.dataset.availableTemplate : this.dataset.unavailableTemplate;

                this.textElement.innerHTML = (template || '').replace(/\[store\]/g, `<b>${name}</b>`);
            }

            if (this.linkElement) this.linkElement.hidden = available;

            this.updateProductStatus(available);
        }

        get addButton() {
            const productForm = document.getElementById(`product-form-${this.sectionId}`);

            return productForm?.querySelector('[name="add"]');
        }

        blockAddButton() {
            const addButton = this.addButton;

            if (addButton && !addButton.disabled) {
                addButton.disabled = true;
                addButton.setAttribute('data-store-oos', 'true');
            }
        }

        updateProductStatus(available) {
            const addButton = this.addButton;
            const addButtonText = addButton?.querySelector('span');

            if (!addButton) return;

            if (!available) {
                addButton.disabled = true;
                addButton.setAttribute('data-store-oos', 'true');

                if (addButtonText) addButtonText.textContent = window.variantStrings.soldOut;
            } else if (addButton.getAttribute('data-store-oos') === 'true') {
                addButton.removeAttribute('data-store-oos');
                addButton.disabled = false;

                if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
            }
        }
    }

    customElements.define('store-stock', StoreStock);
}
